export enum PlaceholderType {
  Primary = 'primary',
  Secondary = 'secondary',
  Tertiary = 'tertiary',
  Quaternary = 'quaternary',
}

export type PlaceholderDimension = `${number}px` | `${number}%` | 'auto' | null | undefined;

export const PlaceholderDefaultDimension = '300px';
